export const data = [
  {
    buildingId: 41136,
    address: "Yonge St Apartments",
    intensity: 124,
    distraction: 130,
    forgetfulness: 52,
  },
  {
    buildingId: 50079,
    address: "The Bayshore Condominium, 1 Mowat Av",
    intensity: 111,
    distraction: 102,
    forgetfulness: 66,
  },
  {
    buildingId: 48557,
    address: "The Westen Apartments, 845 Gariners Rd",
    intensity: 119,
    distraction: 110,
    forgetfulness: 49,
  },
  {
    buildingId: 44706,
    address: "Elliott Ave Apartments",
    intensity: 112,
    distraction: 72,
    forgetfulness: 90,
  },
  {
    buildingId: 11796,
    address: "Kingston Frontenac Housing Corporation, 129 Van Order Dr",
    intensity: 130,
    distraction: 88,
    forgetfulness: 54,
  },
  {
    buildingId: 82135,
    address: "Division St Apartments",
    intensity: 79,
    distraction: 114,
    forgetfulness: 78,
  },
  {
    buildingId: 82137,
    address: "William St Apartments",
    intensity: 103,
    distraction: 96,
    forgetfulness: 68,
  },
  {
    buildingId: 4048,
    address: "Marland St Apartments",
    intensity: 48,
    distraction: 148,
    forgetfulness: 70,
  },
  {
    buildingId: 83299,
    address: "Green Park Apartments, 180 Queen Mary Rd",
    intensity: 36,
    distraction: 139,
    forgetfulness: 91,
  },
  {
    buildingId: 13514,
    address: "Amanda St Apartments",
    intensity: 78,
    distraction: 103,
    forgetfulness: 79,
  },
  {
    buildingId: 53991,
    address: "L'Hermitage East Apartments, 860 Norwest Rd",
    intensity: 60,
    distraction: 140,
    forgetfulness: 56,
  },
  {
    buildingId: 43110,
    address: "Virginia Street Apartments",
    intensity: 111,
    distraction: 61,
    forgetfulness: 83,
  },
  {
    buildingId: 49637,
    address: "Fort Haldimand-Champlain Quarters",
    intensity: 78,
    distraction: 107,
    forgetfulness: 68,
  },
  {
    buildingId: 54002,
    address: "An Clachan Complex, Coop, 17 Van Order Dr",
    intensity: 108,
    distraction: 54,
    forgetfulness: 84,
  },
  {
    buildingId: 41175,
    address: "Crescent Towers FCC, 130 Wright Cr",
    intensity: 122,
    distraction: 49,
    forgetfulness: 75,
  },
  {
    buildingId: 53674,
    address: "Elliott Ave Apartments",
    intensity: 110,
    distraction: 94,
    forgetfulness: 39,
  },
  {
    buildingId: 52192,
    address: "Royal George Condominium",
    intensity: 47,
    distraction: 133,
    forgetfulness: 60,
  },
  {
    buildingId: 41114,
    address: "Earl St Apartments",
    intensity: 79,
    distraction: 74,
    forgetfulness: 86,
  },
  {
    buildingId: 48243,
    address: "Westdale Apartments",
    intensity: 64,
    distraction: 99,
    forgetfulness: 75,
  },
  {
    buildingId: 52113,
    address: "The Bradstreet Apartments, 90 Curtis Cr",
    intensity: 31,
    distraction: 105,
    forgetfulness: 99,
  },
  {
    buildingId: 47547,
    address: "Main Rd Condominiums",
    intensity: 37,
    distraction: 123,
    forgetfulness: 74,
  },
  {
    buildingId: 71085,
    address: "Conacher Dr Apartments",
    intensity: 77,
    distraction: 81,
    forgetfulness: 74,
  },
  {
    buildingId: 1154,
    address: "Regent St Apartments",
    intensity: 91,
    distraction: 71,
    forgetfulness: 67,
  },
  {
    buildingId: 135,
    address: "Frontenac St Apartments",
    intensity: 70,
    distraction: 98,
    forgetfulness: 60,
  },
  {
    buildingId: 64433,
    address: "Kanellos Towers, 544 College St Apartments",
    intensity: 87,
    distraction: 60,
    forgetfulness: 78,
  },
  {
    buildingId: 47481,
    address: "CFB Kingston Apartment Housing",
    intensity: 153,
    distraction: 64,
    forgetfulness: 7,
  },
  {
    buildingId: 2861,
    address: "Westview Place Apartments, 52 Bayswater Pl",
    intensity: 80,
    distraction: 91,
    forgetfulness: 52,
  },
  {
    buildingId: 52950,
    address: "Newcourt Fields 1 Apartments, 44 Old Oak Rd",
    intensity: 71,
    distraction: 80,
    forgetfulness: 69,
  },
  {
    buildingId: 50324,
    address: "Alexander Rd Condominiums",
    intensity: 103,
    distraction: 49,
    forgetfulness: 67,
  },
  {
    buildingId: 13605,
    address: "West Village Apartments, 507 Days Rd",
    intensity: 102,
    distraction: 65,
    forgetfulness: 51,
  },
  {
    buildingId: 35790,
    address: "Sydenham St Apartments",
    intensity: 71,
    distraction: 56,
    forgetfulness: 89,
  },
  {
    buildingId: 49306,
    address: "Adelaide St Apartments",
    intensity: 68,
    distraction: 115,
    forgetfulness: 31,
  },
  {
    buildingId: 51056,
    address: "CFB Kingston Apartment Housing",
    intensity: 83,
    distraction: 41,
    forgetfulness: 89,
  },
  {
    buildingId: 26643,
    address: "CFB Kingston Apartment Housing",
    intensity: 67,
    distraction: 76,
    forgetfulness: 68,
  },
  {
    buildingId: 6367,
    address: "Porto Village Apartments, 700 Divison St",
    intensity: 29,
    distraction: 105,
    forgetfulness: 76,
  },
  {
    buildingId: 7970,
    address: "Kingsdale Av Condominium",
    intensity: 70,
    distraction: 78,
    forgetfulness: 62,
  },
  {
    buildingId: 82871,
    address: "The Caravel Apartments, 64 Ontario St",
    intensity: 73,
    distraction: 74,
    forgetfulness: 61,
  },
  {
    buildingId: 83029,
    address: "Virginia Street Apartments",
    intensity: 48,
    distraction: 96,
    forgetfulness: 63,
  },
  {
    buildingId: 13008,
    address: "Queen Mary Rd Apartments",
    intensity: 84,
    distraction: 58,
    forgetfulness: 63,
  },
  {
    buildingId: 47791,
    address: "Wright Cr Apartments (KFHC)",
    intensity: 46,
    distraction: 85,
    forgetfulness: 74,
  },
  {
    buildingId: 2413,
    address: "Brock Towers",
    intensity: 74,
    distraction: 101,
    forgetfulness: 27,
  },
  {
    buildingId: 52930,
    address: "Westside Stories 1 Apartment, 1610 Bath Rd",
    intensity: 53,
    distraction: 93,
    forgetfulness: 56,
  },
  {
    buildingId: 43993,
    address: "Fort Haldimand-Champlain Quarters",
    intensity: 101,
    distraction: 34,
    forgetfulness: 67,
  },
  {
    buildingId: 52992,
    address: "Princess St Studios and Suites, 682 Princess St",
    intensity: 60,
    distraction: 96,
    forgetfulness: 45,
  },
  {
    buildingId: 51012,
    address: "CFB Kingston Apartment Housing",
    intensity: 37,
    distraction: 116,
    forgetfulness: 47,
  },
  {
    buildingId: 47428,
    address: "CFB Kingston Apartment Housing",
    intensity: 84,
    distraction: 62,
    forgetfulness: 53,
  },
  {
    buildingId: 12593,
    address: "Kingsdale Av Condominium",
    intensity: 67,
    distraction: 93,
    forgetfulness: 39,
  },
  // {
  //   buildingId: 52655,
  //   address: null,
  //   intensity: 64,
  //   distraction: 62,
  //   forgetfulness: 72,
  // },
  {
    buildingId: 2463,
    address: "Cataraqui Ridge Apartments, 267 Parkway",
    intensity: 73,
    distraction: 85,
    forgetfulness: 40,
  },
  {
    buildingId: 1052,
    address: "Lord Sydenham Apartments, 32 Ontario St",
    intensity: 88,
    distraction: 42,
    forgetfulness: 67,
  },
  {
    buildingId: 8023,
    address: "Conacher Dr Apartments",
    intensity: 84,
    distraction: 91,
    forgetfulness: 22,
  },
  {
    buildingId: 53547,
    address: "Victoria St Apartments",
    intensity: 58,
    distraction: 74,
    forgetfulness: 65,
  },
  {
    buildingId: 15919,
    address: "Tournay Hall Quarters",
    intensity: 81,
    distraction: 66,
    forgetfulness: 49,
  },
  {
    buildingId: 442,
    address: "Bayswater Pl Apartments",
    intensity: 94,
    distraction: 63,
    forgetfulness: 39,
  },
  {
    buildingId: 3219,
    address: "William St Apartments",
    intensity: 60,
    distraction: 60,
    forgetfulness: 73,
  },
  {
    buildingId: 53192,
    address: "Mayfair, 1508 Princess St",
    intensity: 46,
    distraction: 54,
    forgetfulness: 89,
  },
  {
    buildingId: 52184,
    address: "Fort Lasalle Dormitory",
    intensity: 82,
    distraction: 44,
    forgetfulness: 62,
  },
  {
    buildingId: 48211,
    address: "Charlie Rd Apartments",
    intensity: 95,
    distraction: 38,
    forgetfulness: 54,
  },
  {
    buildingId: 80734,
    address: "Castell Rd Apartments",
    intensity: 75,
    distraction: 74,
    forgetfulness: 37,
  },
  {
    buildingId: 52689,
    address: "Westdale Av Apartments",
    intensity: 88,
    distraction: 57,
    forgetfulness: 39,
  },
  {
    buildingId: 40933,
    address: "Pine St Apartments",
    intensity: 63,
    distraction: 82,
    forgetfulness: 39,
  },
  {
    buildingId: 54124,
    address: "MacDonald Apartments, 26 Leroy Grant Dr",
    intensity: 129,
    distraction: 36,
    forgetfulness: 18,
  },
  {
    buildingId: 72001,
    address: "The Valleyview, 649 Davis Dr Condominium",
    intensity: 136,
    distraction: 2,
    forgetfulness: 43,
  },
  {
    buildingId: 787,
    address: "The Herkimer, 58 Leroy Grant Dr",
    intensity: 59,
    distraction: 82,
    forgetfulness: 39,
  },
  {
    buildingId: 1361,
    address: "Kingsdale Av Condominium",
    intensity: 41,
    distraction: 83,
    forgetfulness: 55,
  },
  {
    buildingId: 47488,
    address: "Pine St Apartments",
    intensity: 53,
    distraction: 68,
    forgetfulness: 57,
  },
  {
    buildingId: 22094,
    address: "John St Apartments",
    intensity: 61,
    distraction: 42,
    forgetfulness: 72,
  },
  {
    buildingId: 41680,
    address: "CFB Quarters, 4 Sadie Av",
    intensity: 63,
    distraction: 90,
    forgetfulness: 19,
  },
  {
    buildingId: 46465,
    address: "Colborne St Apartments",
    intensity: 103,
    distraction: 45,
    forgetfulness: 23,
  },
  {
    buildingId: 53252,
    address: "Glengarry Apartments - 94 Wright Crescent",
    intensity: 101,
    distraction: 37,
    forgetfulness: 31,
  },
  {
    buildingId: 46093,
    address: "Palace Rd Apartments",
    intensity: 81,
    distraction: 38,
    forgetfulness: 48,
  },
  {
    buildingId: 39803,
    address: "Castell Road Apartments - Skyline Living",
    intensity: 13,
    distraction: 75,
    forgetfulness: 78,
  },
  {
    buildingId: 42347,
    address: "Bath Rd Apartments 2001",
    intensity: 63,
    distraction: 49,
    forgetfulness: 54,
  },
  {
    buildingId: 628,
    address: "An Clachan Complex, Coop, 15 Macpherson Av",
    intensity: 65,
    distraction: 37,
    forgetfulness: 60,
  },
  {
    buildingId: 74374,
    address: "Marion Community Homes, 480 Days Rd",
    intensity: 26,
    distraction: 70,
    forgetfulness: 66,
  },
  {
    buildingId: 3214,
    address: "Armstrong Rd Condominiums",
    intensity: 42,
    distraction: 70,
    forgetfulness: 47,
  },
  {
    buildingId: 247,
    address: "York St Aprtments",
    intensity: 40,
    distraction: 75,
    forgetfulness: 43,
  },
  {
    buildingId: 53646,
    address: "Village Tower Apartments, 87 Compton St",
    intensity: 49,
    distraction: 71,
    forgetfulness: 37,
  },
  {
    buildingId: 3154,
    address: "Bath Rd Apartments 257",
    intensity: 65,
    distraction: 49,
    forgetfulness: 42,
  },
  {
    buildingId: 41773,
    address: "Town Homes Kingston, 37 Cassidy St",
    intensity: 66,
    distraction: 79,
    forgetfulness: 9,
  },
  {
    buildingId: 42745,
    address: "Van Order Dr (KFHC)",
    intensity: 73,
    distraction: 51,
    forgetfulness: 29,
  },
  {
    buildingId: 53928,
    address: "Park St Apartments",
    intensity: 71,
    distraction: 21,
    forgetfulness: 58,
  },
  {
    buildingId: 15848,
    address: "The West Winds, 111 Notch Hill Rd",
    intensity: 65,
    distraction: 73,
    forgetfulness: 12,
  },
  {
    buildingId: 82637,
    address: "Harbour Place Condominium, 135 Ontario St",
    intensity: 76,
    distraction: 43,
    forgetfulness: 28,
  },
  {
    buildingId: 22298,
    address: "Park St Apartments 264",
    intensity: 41,
    distraction: 60,
    forgetfulness: 45,
  },
  {
    buildingId: 44817,
    address: "Bayswater Pl Apartments",
    intensity: 59,
    distraction: 29,
    forgetfulness: 55,
  },
  {
    buildingId: 53117,
    address: "Bath Rd Apartments 1737",
    intensity: 58,
    distraction: 50,
    forgetfulness: 33,
  },
  {
    buildingId: 66210,
    address: "Van Order Dr Apartments 123 (KFHC)",
    intensity: 60,
    distraction: 56,
    forgetfulness: 23,
  },
  {
    buildingId: 52992,
    address: "Johnson St Apartments",
    intensity: 50,
    distraction: 39,
    forgetfulness: 50,
  },
  {
    buildingId: 3211,
    address: "Lasall II Apartment, 485 Canatara Ct",
    intensity: 86,
    distraction: 20,
    forgetfulness: 32,
  },
  {
    buildingId: 1723,
    address: "Johnson St Apartments 847",
    intensity: 89,
    distraction: 11,
    forgetfulness: 36,
  },
  {
    buildingId: 3219,
    address: "Palace Rd Apartments",
    intensity: 21,
    distraction: 93,
    forgetfulness: 13,
  },
  {
    buildingId: 83394,
    address: "York St Apartments",
    intensity: 55,
    distraction: 38,
    forgetfulness: 34,
  },
  {
    buildingId: 52260,
    address: "Admiralty Place",
    intensity: 93,
    distraction: 20,
    forgetfulness: 12,
  },
  {
    buildingId: 46197,
    address: "Days Rd Apartments",
    intensity: 29,
    distraction: 42,
    forgetfulness: 49,
  },
  {
    buildingId: 52583,
    address: "Portsmouth Place Central Apartments, 310 Bath Rd",
    intensity: 53,
    distraction: 0,
    forgetfulness: 55,
  },
  {
    buildingId: 27224,
    address: "The Sandpiper Apartments, 300 Regent St",
    intensity: 55,
    distraction: 38,
    forgetfulness: 14,
  },
  {
    buildingId: 22064,
    address: "Theresa Cr Apartments",
    intensity: 47,
    distraction: 42,
    forgetfulness: 12,
  },
  {
    buildingId: 82083,
    address: "Shipyards Apartments, 33 Ontario St",
    intensity: 55,
    distraction: 0,
    forgetfulness: 45,
  },
  {
    buildingId: 53404,
    address: "Kingscourt Aparments",
    intensity: 33,
    distraction: 33,
    forgetfulness: 1,
  },
];
